module.exports = __webpack_public_path__ + "img/3_68.89d5a317.png";